import { projects } from "../constants/Constants";

const Projects = () => {
  return (
    <section id="projects">
      <div class="container mx-auto mb-5">
        <div class="md:w-1/2 mb-10">
          <h1 class="text-4xl font-bold text-center md:text-5xl md:text-center">
            Projects
          </h1>
        </div>
        <div class="">
          <div class="flex flex-col items-center md:grid gap-10 grid-custom justify-center">
            {projects.map(
              ({ id, image, title, description, tags, source, visit }) => (
                <card
                  key={id}
                  class="rounded w-10/12 overflow-hidden shadow-md text-darkGrayishBlue md:w-64"
                >
                  <img src={image} class="w-full h-32 sm:h-48 object-cover" />
                  <div class="m-4">
                    <div class="font-semibold text-white text-center">
                      {title}
                    </div>
                    <span class="block text-center  mb-4">{description}</span>
                    <div class="text-center font-semibold text-white">
                      Stack
                    </div>
                    <ul class="flex flex-row justify-around mb-2">
                      {tags.map((tag, i) => (
                        <div key={i}>{tag}</div>
                      ))}
                    </ul>
                    <list class="flex flex-row justify-around">
                      <a
                        href={visit}
                        class="p-3 px-3 pt-2 text-white bg-slate-600  rounded-2xl
                       baseline hover:bg-brightRedLight"
                      >
                        Code
                      </a>

                      <a
                        href={source}
                        class="p-3 px-3 pt-2 text-white bg-slate-600 rounded-2xl
                      baseline hover:bg-brightRedLight"
                      >
                        Source
                      </a>
                    </list>
                  </div>
                </card>
              )
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects;
